import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-consulenza-view',
  templateUrl: './form-consulenza-view.component.html',
  styleUrls: ['./form-consulenza-view.component.css']
})
export class FormConsulenzaViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
